import { hc } from 'hono/client';

import type { MixpanelRoutes } from 'backend-routes';

export const mixpanelClient = () => hc<MixpanelRoutes>(`${import.meta.env.VITE_BACKEND_NODEJS_URL}/mp`);
